const i = {
  name: "WarningDiamondFilled",
  dimensions: { width: 24, height: 24 },
  content: `
        <g>
            <path d="M2.41421 10.5858L10.5858 2.41421C11.3668 1.63317 12.6332 1.63317 13.4142 2.41421L21.5858 10.5858C22.3668 11.3668 22.3668 12.6332 21.5858 13.4142L13.4142 21.5858C12.6332 22.3668 11.3668 22.3668 10.5858 21.5858L2.41421 13.4142C1.63317 12.6332 1.63317 11.3668 2.41421 10.5858Z" fill="currentColor" stroke="currentColor" stroke-width="2"/>
            <path d="M12 7V11" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="12" cy="15.5" r="1.5" fill="white"/>
        </g>
  `
};
export {
  i as WarningDiamondFilled
};
